class FacetFiltersForm extends HTMLElement {
  static controller = new AbortController();
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    // this.debouncedOnSubmit = debounce((event) => {
    //   this.onSubmitHandler(event);
    // }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.onSubmitHandler.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, fixedUrl = null) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    //console.log(window.location.pathname, 'window.location.pathname1')
    // if (fixedUrl) {
    // //console.log(window.location.pathname,'window.location.pathname2')
    //   FacetFiltersForm.renderMainContentFromFetch(fixedUrl);
    //   //console.log(window.location.pathname,'window.location.pathname3')
    // }
    // else {
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    // document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    // sections.forEach((section) => {
    const url = fixedUrl ? fixedUrl : `${window.location.pathname}?${searchParams}`;
    const filterDataUrl = (element) => element.url === url;
    //console.log('linh renderPage')

    FacetFiltersForm.filterData.some(filterDataUrl)
      ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
      : FacetFiltersForm.renderSectionFromFetch(url, event, fixedUrl ? fixedUrl : null);
    // });
    // }
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, fixedUrl);
  }

  static renderSectionFromFetch(url, event, fixedUrl = null) {
    const signal = FacetFiltersForm.controller?.signal;
    fetch(url, { signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event, fixedUrl);
        //console.log('linh renderSectionFromFetch')
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        return true;
      }).catch((error) => {
        //console.log(error)
        return false;
      })
      .finally((res) => {
        // document.querySelector('.hilx_loading').style.display = 'none';
        //console.log('linh', res)
        if (res == true)
          FacetFiltersForm.hideLoading();
      });
  }

  static showLoading() {
    if (document.getElementById('filtered-product-shimmer__wrapper')) {
      document.getElementById('filtered-product-shimmer__wrapper').classList.add('show');
    }
    document.getElementById('product-grid').classList.add('hidden');
  }
  static hideLoading() {
    if (document.getElementById('filtered-product-shimmer__wrapper')) {
      document.getElementById('filtered-product-shimmer__wrapper').classList.remove('show');
    }
    document.getElementById('product-grid').classList.remove('hidden');
  }

  static renderMainContentFromFetch(url) {
    const signal = FacetFiltersForm.controller?.signal;
    fetch(url, { signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.renderMainContent(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        return true;
      }).catch((error) => {
        return false

      })
      .finally((res) => {
        var sliderSelectors = ['#slider-range', '#slider-range-mobile'];
        sliderSelectors.forEach(selector => priceSliderInit(selector));
        // document.querySelector('.hilx_loading').style.display = 'none';
        if (res == true)
          FacetFiltersForm.hideLoading();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    // document.querySelector('.hilx_loading').style.display = 'none';
    FacetFiltersForm.hideLoading();
  }

  static renderProductGridContainer(html) {
    //console.log('linh', 'renderProductGridContainer', html)
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }
  static renderMainContent(html) {
    document.getElementById('main-search-template').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('list-product-grid').innerHTML;

    document
      .getElementById('main-search-template')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML.replace('results', '').replace('result', '');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event, fixedUrl = null) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    if (fixedUrl) {
      document.getElementById('FacetSortForm').innerHTML = parsedHTML.getElementById('FacetSortForm').innerHTML;
      document.getElementById('main-desktop-filters').innerHTML = parsedHTML.getElementById('main-desktop-filters').innerHTML;
    } else {

      const facetDetailsElements = parsedHTML.querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
      );
      const matchesIndex = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
      };
      const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
      const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

      facetsToRender.forEach((element) => {
        const elFound = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
        if (elFound) elFound.innerHTML = element.innerHTML;
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      if (countsToRender) {
        const closestJSFilterID = event.target.closest('.js-filter').id;

        if (closestJSFilterID) {
          FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
          FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

          const newElementSelector = document
            .getElementById(closestJSFilterID)
            .classList.contains('mobile-facets__details')
            ? `#${closestJSFilterID} .mobile-facets__close-button`
            : `#${closestJSFilterID} .facets__summary`;
          const newElementToActivate = document.querySelector(newElementSelector);
          if (newElementToActivate) newElementToActivate.focus();
        }
      }
    }

    var sliderSelectors = ['#slider-range', '#slider-range-mobile'];
    sliderSelectors.forEach(selector => priceSliderInit(selector));

  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams, fixedUrl) {
    if (fixedUrl) {
      history.pushState({ searchParams }, '', fixedUrl);
    }
    else {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    var searchParams = new URLSearchParams(formData).toString();
    var mainProductFilter = `filter.p.m.custom.ismainproduct=1`;
    return (window.location.pathname.includes('/search') && !searchParams.includes(mainProductFilter)) ?
      `${mainProductFilter}&`.concat(searchParams) :
      searchParams;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    // //console.log('searchParams', searchParams)

  }

  onSubmitHandler(event) {
    event.preventDefault();
    var target = event.target;
    if (target.name == "filter.p.m.custom.is_replacement_lens" && window.location.pathname.includes('/collections/')) {
      var formInput = this.querySelectorAll(`input[name="${target.name}"]`);
      for (let index = 0; index < formInput.length; index++) {
        const el = formInput[index];
        if (el.value != target.value) {
          el.setAttribute("checked", !target.checked);
          if (target.checked) {
            el.removeAttribute('checked');
          }
        }
      }

    }

    // document.querySelector('.hilx_loading').style.display = 'block';
    FacetFiltersForm.controller?.abort();
    FacetFiltersForm.controller = new AbortController();
    FacetFiltersForm.showLoading();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    // document.querySelector('.hilx_loading').style.display = 'block';
    FacetFiltersForm.controller?.abort();
    FacetFiltersForm.controller = new AbortController();
    FacetFiltersForm.showLoading();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    if (window.location.pathname.includes('/search') && event.currentTarget.href.includes('/collections')) {
      var search = '';
      if (url) {
        var queries = url.split('&');
        var filters = [];
        queries.forEach(q => {
          if (!q.startsWith('q=') && !q.startsWith('options%5Bprefix%5D=') && !q.startsWith('options[prefix]=')) {
            filters.push(q);
          }
        });
        search = filters.join('&');
      }
      //console.log('renderProductGridContainer', url, window.location.pathname, event.currentTarget.href)
      FacetFiltersForm.renderPage(url, null, true, (url ? event.currentTarget.href.replace(url, search) : event.currentTarget.href))
    }
    else {
      FacetFiltersForm.renderPage(url);
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
function priceSliderInit(selector) {
  if ($('.facets__header-vertical').length == 0 || !$('.facets__header-vertical').data("currency")) return;
  var input_event = new Event('input', { bubbles: true });
  // var min_val = 0;
  var min_val = parseFloat($('.facets__header-vertical').data("min"));
  var max_val = parseFloat($('.facets__header-vertical').data("max"));
  var currency = $('.facets__header-vertical').data("currency").trim();
  var current_min = 0;
  if ($('price-range input.min').val()) {
    current_min = $('price-range input.min').val();
  }
  var current_max = $('.facets__header-vertical').data("max");
  if ($('price-range input.max').val()) {
    current_max = $('price-range input.max').val();
  }
  if ($(selector).length) {
    $(selector).slider({
      range: true,
      min: min_val,
      max: max_val,
      values: [current_min, current_max],
      slide: function (event, ui) {
        $('.range-value input.min').val(currency + ' ' + ui.values[0])
        $('.range-value input.max').val(currency + ' ' + ui.values[1])

        var target_min = document.querySelector('price-range input.min');
        $('price-range input.min').val(ui.values[0]).trigger('change').trigger('input')
        // target_min.dispatchEvent(changed_event);
        target_min.dispatchEvent(input_event);

        var target_max = document.querySelector('price-range input.max');
        $('price-range input.max').val(ui.values[1]).trigger('change').trigger('input')
        // target_min.dispatchEvent(changed_event);
        target_max.dispatchEvent(input_event);
      }
    });
    $('.range-value input.min').val(currency + ' ' + $(selector).slider("values", 0))
    $('.range-value input.max').val(currency + ' ' + $(selector).slider("values", 1))
  }
}
